import { Avatar, DropdownMenu } from '@octopus-do/octopus-storybook'
import { OctopusMonoLogo } from '@octopus-do/octopus-storybook/icons'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  url: string | null
  color: string
  name: string
}

export const AvatarButton = forwardRef<HTMLButtonElement, Props>(
  ({ url, color, name }, ref) => {
    const { open, active } = DropdownMenu.useTrigger()

    return (
      <button
        ref={ref}
        onClick={open}
        type="button"
        className={clsJoin(css.avatar_button, active && css.active)}
      >
        {url && <Avatar media={url} size="lg" name={name} color={color} />}
        {!url && <OctopusMonoLogo className={css.empty_logo} />}
      </button>
    )
  }
)
